<hq-sort-menu-option *ngFor="let option of sortOptions"
                     mat-ripple
                     [sortOption]="option"
                     [isSelected]="option.isSelected"
                     [sortDirection]="option.sortDirection"
                     (selectOption)="onSelectSortOption($event)">
</hq-sort-menu-option>
